import {
  ColumnLayout,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import PLCNumberEditor from 'features/plc/components/PLCNumberEditor';
import PropTypes from 'prop-types';
import React from 'react';

export default function PLCFields({
  title = null,
  description = null,
  fields,
  fieldColumns = 1,
}) {
  return (
    <SpaceBetween size="xs">
      {title && (
        <Header
          variant="h3"
          description={description}
        >
          {title}
        </Header>
      )}
      <ColumnLayout columns={fieldColumns}>
        {fields.map((field) => (
          <PLCNumberEditor
            key={field.path.name}
            field={field}
          />
        ))}
      </ColumnLayout>
    </SpaceBetween>
  );
}

PLCFields.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  fields: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    max: PropTypes.number,
    min: PropTypes.number,
    path: PropTypes.shape({
      name: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }).isRequired,
  })).isRequired,
  fieldColumns: PropTypes.number,
};
